export class CurrencyModule {
    currencyID: number = 0;
    nameAr: string = '';
    nameEn: string = '';
    rate: number = 0;
    isVisible: boolean = true;
    currFormat: string = '';
    notes: string = '';
 }
